// @flow

import React from 'react';
import styler from 'react-styling';

import Spinner from '../Spinner';

const style = styler `
  Minibrowser
    width: 350px
    height: 225px
    background-color: #ECECEC
    box-shadow: #F5F5F5 0 0 30px
    border-radius: 5px
    border: 1px solid #DBDBDB
    margin-left: auto
    margin-right: auto
  Topbar
    width: 100%
    height: 20px
    bow-shadow: #F5F5F5 0 0 10px
    background-color: #FFF
  Sidebar
    height: 205px
    width: 20px
    background-color: #0A152D
    float: left
  Menu
    color: #FFF
    font-size: 8px
    display: block
    margin-top: 10px
  List
    background-color: #F5F5F5
    width: 100px
    height: 205px
    float: left
    padding-top: 10px
  Line
    background-color: #E5E5E5
    width: 70%
    height: 6px
    border-radius: 3px
    margin-top: 12px
    margin-left: auto
    margin-right: auto
  Content
    width: 228px
    height: 205px
    float: right
  User
    font-size: 80px
    &Pending
      margin-top: 58px
      color: rgba(73, 123, 235, 0.2)
    &Ready
      margin-top: 40px
      color: #497BEB
  Spinner
    position: relative
    top: 41px
    left: 59px
    width: 120px
    height: 120px
  Text
    margin-top: 50px
    margin-bottom: 50px
  LoginButton
    margin-top: 10px
    background-color: #497BEB
    display: block
    width: 65px
    margin-left: auto
    margin-right: auto
    border: 0
    padding: 8px
    border-radius: 4px
`;

const _renderSignupReadyStatus = (lang: Object) => (
  <div>
    <div style={style.Minibrowser}>
      <div style={style.Topbar} />
      <div style={style.Sidebar}>
        <i className="fa fa-user" style={style.Menu} />
        <i className="fa fa-car" style={style.Menu} />
        <i className="fa fa-star" style={style.Menu} />
        <i className="fa fa-clock-o" style={style.Menu} />
      </div>
      <div style={style.List}>
        <div style={style.Line} /><div style={style.Line} /><div style={style.Line} /><div style={style.Line} /><div style={style.Line} /><div style={style.Line} /><div style={style.Line} /><div style={style.Line} />
      </div>
      <div style={style.Content}>
        <i className="fa fa-user" style={style.User.Ready} />
        <a href="/login?provider=o365" className="btn btn-success" style={style.LoginButton}>{lang.login}</a>
      </div>
    </div>
    <div style={style.Text}>
      <span style={{ fontSize: '30px', display: 'block', color: '#333', marginBottom: '10px' }}>{lang.signup_ready}</span>
    </div>
  </div>
);

const _renderSignupPendingStatus = (lang: Object) => (
  <div>
    <div style={style.Minibrowser}>
      <div style={style.Topbar} />
      <div style={style.Sidebar}>
        <i className="fa fa-user" style={style.Menu} />
        <i className="fa fa-car" style={style.Menu} />
        <i className="fa fa-star" style={style.Menu} />
        <i className="fa fa-clock-o" style={style.Menu} />
      </div>
      <div style={style.List}>
        <div style={style.Line} /><div style={style.Line} /><div style={style.Line} /><div style={style.Line} /><div style={style.Line} /><div style={style.Line} /><div style={style.Line} /><div style={style.Line} />
      </div>
      <div style={style.Content}>
        <i className="fa fa-user" style={style.User.Pending} />
      </div>
      <Spinner style={style.Spinner} />
    </div>
    <div style={style.Text}>
      <span style={{ fontSize: '30px', display: 'block', color: '#333', marginBottom: '10px' }}>{lang.signup_pending}</span>
      <span>{lang.signup_pending_instructions}</span>
    </div>
  </div>
);

type Props = {
  lang: Object,
  status: string,
};

const SignupStatusPage = (props: Props) => {
  const { lang, status } = props;
  return (
    <div>{status === 'ready' ? _renderSignupReadyStatus(lang) : _renderSignupPendingStatus(lang)}</div>
  );
};

export default SignupStatusPage;



// WEBPACK FOOTER //
// ./src/js/Components/Signup/SignupStatusPage.js